import { render, staticRenderFns } from "./ProductReportsDashboardSkuBriefModal.vue?vue&type=template&id=71763eed&scoped=true"
import script from "./ProductReportsDashboardSkuBriefModal.vue?vue&type=script&lang=js"
export * from "./ProductReportsDashboardSkuBriefModal.vue?vue&type=script&lang=js"
import style0 from "./ProductReportsDashboardSkuBriefModal.vue?vue&type=style&index=0&id=71763eed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71763eed",
  null
  
)

export default component.exports